import script from "./CourseSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSidebar.vue?vue&type=script&setup=true&lang=js"

import "./CourseSidebar.vue?vue&type=style&index=0&id=b59d0e04&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b59d0e04"]])

export default __exports__